import App from './App';

import { connect } from 'react-redux';
import { showPreview, closePreview } from './redux';

// AppContainer.js
const mapStateToProps = state => ({
	preview: state.preview,
  });
  
  const mapDispatchToProps = {
	showPreview,
	closePreview,
  };
  
  const AppContainer = connect(
	mapStateToProps,
	mapDispatchToProps
  )(App);
  
  export default AppContainer;
